import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/dashboard/overview')({
  ssr: false, // CSR only - no SEO needed
  loader: async ({ context }) => {
    return { initialTab: 'overview' }
  },
})
